<template>
  <div class="preference content-container flex-column">
    <!-- Pasek menu -->
    <div class="d-flex preference-section-container no-content">
      <div class="preference-section"></div>
      <div class="content-wrap">
        <TopMenu />
      </div>
    </div>

    <!-- Sekcja danych użytkownika -->
    <div class="d-flex preference-section-container">
      <div class="preference-section">
        <span>
          {{ t('user-data') }}
        </span>
      </div>
      <div class="content-wrap">
        <h3>{{ t('account-data') }}</h3>
        <div class="collapse show" id="userData">
          <div class="card-body">
            <!-- Formularz edycji danych użytkownika -->
            <Form
              @submit="onSubmit"
              :validation-schema="schema"
              v-slot="{ errors, isSubmitting }"
            >
              <!-- Pola imię, nazwisko, e-mail -->
              <div class="column d-flex justify-content-center">
                <div class="col-sm-6">
                  <!-- Imię -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('name') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="firstName"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.firstName }"
                        v-model="userData.firstName"
                      />
                      <div class="invalid-feedback">{{ errors.firstName }}</div>
                    </div>
                  </div>
                  <!-- Nazwisko -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('lastname') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="lastName"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.lastName }"
                        v-model="userData.lastName"
                      />
                      <div class="invalid-feedback">{{ errors.lastName }}</div>
                    </div>
                  </div>
                  <!-- Email -->
                  <div class="form-group row mb-3">
                    <label class="col-sm-4 col-form-label">{{ t('email') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="email"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.email }"
                        v-model="userData.email"
                      />
                      <div class="invalid-feedback">{{ errors.email }}</div>
                    </div>
                  </div>
                </div>
                <!-- Pola telefon, hasło -->
                <div class="col-sm-6 phone">
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('phone') }}:</label>
                    <div class="col-sm-2">
                      <Field
                        name="phoneNumberDir"
                        type="text"
                        class="form-control"
                        :disabled="true"
                        v-model="userData.phoneNumberDir"
                      />
                    </div>
                    <div class="col-sm-6">
                      <Field
                        name="phoneNumber"
                        type="text"
                        class="form-control"
                        :class="{
                          'is-invalid':
                            errors.phoneNumber ||
                            (processError != null
                              ? processError.includes('phoneNumber')
                              : false),
                        }"
                        v-model="userData.phoneNumber"
                      />
                      <div class="invalid-feedback">
                        {{ errors.phoneNumber }}
                      </div>
                    </div>
                  </div>
                  <!-- Hasło -->
                  <div class="form-group row mb-3">
                    <label class="col-sm-4 col-form-label">{{ t('password') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="password"
                        type="password"
                        class="form-control"
                        :class="{ 'is-invalid': errors.password }"
                        v-model="userData.password"
                      />
                      <div class="invalid-feedback">{{ errors.password }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Komunikaty i przycisk zapisu -->
              <div class="form-group row d-flex flex-column align-items-center">
                <div class="col-auto" v-if="processError">
                  <div class="process-error form-control">
                    {{ processError }}
                  </div>
                </div>
                <div class="col-auto" v-if="processSuccess">
                  <div class="process-success form-control">
                    {{ processSuccess }}
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    class="btn button-save"
                    :disabled="isSubmitting"
                  >
                    <span
                      v-show="isSubmitting"
                      class="spinner-border spinner-border-sm mr-1"
                    ></span>
                    {{ t('save').toUpperCase() }}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Sekcja zmiany hasła -->
    <div class="d-flex preference-section-container">
      <div class="preference-section">
        <span>{{ t('password-change') }}</span>
      </div>
      <div class="content-wrap">
        <h3>{{ t('password-change') }}</h3>
        <div class="collapse show" id="passData">
          <div class="card-body">
            <!-- Formularz zmiany hasła -->
            <Form
              @submit="onSubmitPass"
              :validation-schema="schemaPass"
              v-slot="{ errors, isPassSubmitting }"
              :keepValues="false"
            >
              <div class="column d-flex justify-content-center user-data">
                <div class="col-sm-6">
                  <!-- Pole stare hasło -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('old-password') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="password"
                        type="password"
                        class="form-control"
                        v-model="form.password"
                        :class="{ 'is-invalid': errors.password }"
                      />
                      <div class="invalid-feedback">{{ errors.password }}</div>
                    </div>
                  </div>
                  <!-- Pole nowe hasło -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('new-password') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="password2"
                        type="password"
                        class="form-control"
                        v-model="form.password2"
                        :class="{ 'is-invalid': errors.password2 }"
                      />
                      <div class="invalid-feedback">{{ errors.password2 }}</div>
                    </div>
                  </div>
                  <!-- Miernik siły hasła -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('password-strength-level') }}:</label>
                    <div class="col-sm-8">
                      <password-meter :password="form.password2" />
                      <div class="d-flex password-meter center-aligned justify-content-center">
                        <div class="col-sm-4">Słabe</div>
                        <div class="col-sm-4">Średnie</div>
                        <div class="col-sm-4">Silne</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6"></div>
              </div>
              <!-- Generator haseł i przyciski -->
              <div class="column d-flex justify-content-center">
                <div class="form-group col">
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('password-proposal') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="proposed"
                        type="text"
                        class="form-control"
                        v-model="form.proposed"
                      />
                    </div>
                  </div>
                </div>
                <div class="col generate-pass">
                  <div class="form-group row">
                    <div class="col-sm-4">
                      <!-- Przycisk generowania hasła -->
                      <button
                        type="button"
                        @click="generatePassword"
                        class="btn button-add-user generate"
                      >
                        {{ t('generate').toUpperCase() }}
                      </button>
                    </div>
                    <div class="col-sm-7">
                      <!-- Przycisk wstawienia wygenerowanego hasła -->
                      <button
                        type="button"
                        @click="usePassword"
                        class="btn button-add-user use-password"
                        :disabled="!form.proposed"
                      >
                        {{ t('use-suggested-password') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row d-flex flex-column align-items-center">
                <div class="col-auto">
                  <!-- Przycisk zmiany hasła -->
                  <button
                    class="btn button-save"
                    :disabled="isPassSubmitting"
                  >
                    <span
                      v-show="isPassSubmitting"
                      class="spinner-border spinner-border-sm mr-1"
                    ></span>
                    {{ t('change-password').toUpperCase() }}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>

    <!-- Sekcja ustawień konta -->
    <div class="d-flex preference-section-container">
      <div class="preference-section">
        <span>{{ t('settings') }}</span>
      </div>
      <div class="content-wrap">
        <h3>{{ t('settings') }}</h3>
        <div class="collapse show" id="settingsData">
          <div class="card-body">
            <!-- Formularz ustawień preferencji -->
            <Form
              name="settingsForm"
              @submit="onSubmitSettings"
              :validation-schema="schemaPreferences"
              v-slot="{ errors, isSettingsSubmitting }"
            >
              <div class="column d-flex justify-content-center">
                <div class="col-sm-6">
                  <!-- Dodatkowy czas od punktu kontrolnego -->
                  <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{ t('time-from-checkpoint') }}:</label>
                    <div class="col-sm-8">
                      <Field
                        name="checkpointAdditionalTime"
                        type="text"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.checkpointAdditionalTime,
                        }"
                        v-model="preferences.checkpointAdditionalTime"
                      />
                      <div class="invalid-feedback">
                        {{ errors.checkpointAdditionalTime }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 metrics-panel-wrap">
                  <div class="metrics-panel">
                    <div class="metrics-panel-header">
                      <span class="metrics-panel-title">{{ t('vehicle-list-properties') }}</span>
                      <span class="metrics-panel-counter">{{ selectedMetricsCount }}/3</span>
                    </div>

                    <input
                      type="text"
                      class="form-control metrics-search"
                      v-model="metricSearch"
                      :placeholder="t('search')"
                    />

                    <div class="metrics-list">
                      <label
                        v-for="option in filteredVehicleMetricOptions"
                        :key="option.id"
                        class="metrics-item"
                      >
                        <input
                          type="checkbox"
                          :checked="isMetricSelected(option.id)"
                          :disabled="isMetricDisabled(option.id)"
                          @change="toggleMetric(option.id, $event.target.checked)"
                        />
                        <span>{{ t(option.labelKey) }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Komunikaty i przycisk zapisu -->
              <div class="form-group row d-flex flex-column align-items-center mb-4">
                <div id="settings-feedback" class="col-12 settings-feedback" v-if="processSettingsError">
                  <div class="settings-alert settings-alert--error" role="alert">
                    <span>{{ processSettingsError }}</span>
                    <button
                      type="button"
                      class="settings-alert-close"
                      aria-label="Zamknij"
                      @click="closeSettingsAlert('error')"
                    >
                      &times;
                    </button>
                  </div>
                </div>
                <div id="settings-feedback" class="col-12 settings-feedback" v-if="processSettingsSuccess">
                  <div class="settings-alert settings-alert--success" role="alert">
                    <span>{{ processSettingsSuccess }}</span>
                    <button
                      type="button"
                      class="settings-alert-close"
                      aria-label="Zamknij"
                      @click="closeSettingsAlert('success')"
                    >
                      &times;
                    </button>
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    class="btn button-save"
                    :disabled="isSettingsSubmitting"
                  >
                    <span
                      v-show="isSettingsSubmitting"
                      class="spinner-border spinner-border-sm mr-1"
                    ></span>
                    {{ t('set').toUpperCase() }}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import * as Yup from "yup";
import { useI18n } from 'vue-i18n';
import { Form, Field } from 'vee-validate';
const { t } = useI18n();

// Schemat walidacji dla danych użytkownika
const schema = Yup.object().shape({
  firstName: Yup.string(),
  lastName: Yup.string(),
  password: Yup.string().required(t('user-password-required')),
  email: Yup.string().email(t('incorrect-email-address')),
  phoneNumber: Yup.string().required(t('user-phone-required')),
});

// Schemat walidacji dla preferencji
const schemaPreferences = Yup.object().shape({
  checkpointAdditionalTime: Yup.number(),
  vehicleListMetricIds: Yup.array(),
});

// Schemat walidacji dla zmiany hasła
const schemaPass = Yup.object().shape({
  password: Yup.string().required(t('user-password-required')),
  password2: Yup.string().required(t('user-password-required')),
});
</script>

<script>
import TopMenu from "@/components/TopMenu.vue";
import { ref } from "vue";
import PasswordMeter from "vue-simple-password-meter";
import { useErrorStore } from "@/stores/error.store";
import { useUserStore } from "@/stores/user.store";

export default {
  name: "PreferenceView",
  components: {
    TopMenu,
    PasswordMeter,
  },
  data() {
    const userStore = useUserStore();
    return {
      userStore,
      userData: {},
      preferences: {},
      form: {
        password: ref(""),
        password2: ref(""),
        proposed: ref(""),
      },
      getPasswordLength: 14,
      errorsStore: useErrorStore(),
      processSettingsSuccess: null,
      processSettingsError: null,
      processError: null,
      processSuccess: null,
      metricSearch: "",
    };
  },
  async mounted() {
    // Pobierz dane użytkownika po załadowaniu widoku
    await this.userStore.self();
    this.userData = this.userStore.currentUser;
    this.preferences = {
      ...this.userStore.preferences,
      vehicleListMetricIds: (this.userStore.preferences?.vehicleListMetricIds || []).map(String),
    };
  },
  computed: {
    selectedMetricsCount() {
      // console.log("Selected metrics:", this.preferences.vehicleListMetricIds);
      return Array.isArray(this.preferences?.vehicleListMetricIds)
        ? this.preferences.vehicleListMetricIds.length
        : 0;
    },
    filteredVehicleMetricOptions() {
      // console.log("Filtering metrics with search:", this.metricSearch);
      const q = (this.metricSearch || "").trim().toLowerCase();
      const options = this.userStore.vehicleListDisplayProperties || [];
      if (!q) {
        return options;
      }

      return options.filter((opt) => this.$t(opt.labelKey).toLowerCase().includes(q));
    },
  },
  methods: {
    setSettingsAlert(type, message) {
      this.processSettingsSuccess = null;
      this.processSettingsError = null;

      if (type === "success") {
        this.processSettingsSuccess = message;
      } else if (type === "error") {
        this.processSettingsError = message;
      }

      this.$nextTick(() => {
        const feedback = document.getElementById("settings-feedback");
        if (feedback) {
          feedback.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    },
    closeSettingsAlert(type) {
      if (type === "success") {
        this.processSettingsSuccess = null;
      } else if (type === "error") {
        this.processSettingsError = null;
      } else {
        this.processSettingsSuccess = null;
        this.processSettingsError = null;
      }
    },
    isMetricSelected(id) {
      // console.log("Checking if metric is selected:", id, this.preferences.vehicleListMetricIds);
      const selected = this.preferences?.vehicleListMetricIds || [];
      return selected.includes(String(id));
    },
    isMetricDisabled(id) {
      // console.log("Checking if metric is disabled:", id, this.preferences.vehicleListMetricIds);
      const selected = this.preferences?.vehicleListMetricIds || [];
      const idStr = String(id);
      if (selected.includes(idStr)) {
        return false;
      }

      return selected.length >= 3;
    },
    toggleMetric(id, checked) {
      // console.log("Toggling metric:", id, checked);
      if (!Array.isArray(this.preferences.vehicleListMetricIds)) {
        this.preferences.vehicleListMetricIds = [];
      }

      const idStr = String(id);
      const selected = this.preferences.vehicleListMetricIds;

      if (checked) {
        if (selected.includes(idStr)) {
          return;
        }
        if (selected.length >= 3) {
          const msg = this.$t('max-three-vehicle-list-properties');
          this.setSettingsAlert("error", msg);
          this.errorsStore.showErrorMessage(msg);
          return;
        }
        selected.push(idStr);
        return;
      }

      this.preferences.vehicleListMetricIds = selected.filter((val) => val !== idStr);
    },
    // Złożenie numeru telefonu z prefixem i numerem
    getPhoneNumber: function (values) {
      return (
        (values.phoneNumberDir
          ? values.phoneNumberDir.replaceAll(" ", "")
          : "") +
        (values.phoneNumber ? values.phoneNumber.replaceAll(" ", "") : "")
      );
    },
    // Obsługa submitu dla danych użytkownika
    async onSubmit(values) {
      const userStore = useUserStore();
      const sendUser = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        password: values.password,
        phoneNumber: this.getPhoneNumber(values),
      };
      this.errorsStore.clearErrorMessage();
      const updatedData = await userStore.update(sendUser);
      if (!updatedData.error) {
        this.errorsStore.showSuccessMessage(this.$t('data-saved-correctly'));
      } else {
        this.errorsStore.showErrorMessage(updatedData.error);
      }
    },
    // Obsługa submitu dla ustawień preferencji
    async onSubmitSettings(values) {
      const userStore = useUserStore();
      this.errorsStore.clearErrorMessage();
      this.setSettingsAlert(null, null);
      const selectedMetricIds = (this.preferences?.vehicleListMetricIds || [])
        .map((id) => parseInt(id))
        .filter((id) => Number.isInteger(id) && id > 0);

      if (selectedMetricIds.length > 3) {
        const msg = this.$t('max-three-vehicle-list-properties');
        this.setSettingsAlert("error", msg);
        this.errorsStore.showErrorMessage(msg);
        return;
      }

      const sendUser = {
        checkpointAdditionalTime: parseInt(values.checkpointAdditionalTime),
        vehicleListMetricIds: selectedMetricIds,
      };
      const updatedData = await userStore.updateSettings(sendUser);
      if (!updatedData.error) {
        const msg = this.$t('updated');
        this.setSettingsAlert("success", msg);
        this.errorsStore.showSuccessMessage(msg);
      } else {
        const msg = String(updatedData.error);
        this.setSettingsAlert("error", msg);
        this.errorsStore.showErrorMessage(msg);
      }
    },
    // Obsługa submitu dla zmiany hasła
    async onSubmitPass(values) {
      const userStore = useUserStore();
      const sendUser = {
        password: values.password,
        newPassword: values.password2,
      };
      this.errorsStore.clearErrorMessage();
      const updatedData = await userStore.updatePassword(sendUser);
      if (!updatedData.error) {
        this.errorsStore.showSuccessMessage(this.$t('updated'));
      } else {
        this.errorsStore.showErrorMessage(updatedData.error);
      }
    },
    // Generator silnych haseł
    generatePassword() {
      const alphabet =
        "1234567890-=!@#$%^&*()_+qazwsxedcrfvtgbyhnujmik,ol.p;/[]QAZWSXEDCRFVTGBYHNUJMIKOL>P:?{'}|";
      let pass = "";
      for (let i = 0; i < this.getPasswordLength; i++) {
        pass += alphabet[Math.floor(Math.random() * alphabet.length)];
      }
      this.form.proposed = pass;
      return pass;
    },
    // Wstawienie wygenerowanego hasła do pola
    usePassword() {
      this.form.password2 = this.form.proposed;
    },
    setup() {
      const password2 = this.form.password2;
      return {
        password2,
      };
    },
  },
};
</script>

<style scoped>
.process-error {
  color: darkred;
}

.process-success {
  color: #42b983;
}

.col-form-label {
  text-align: right;
}

.content-container > div {
  min-height: auto;
}

.content-wrap .collapse {
  margin-bottom: 20px;
}

.preference-section-container {
  width: 100%;
}

.preference-section {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

.preference-section > span {
  padding: 10px 25px;
  position: relative;
  display: block;
}

.content-wrap h3 {
  margin-bottom: 0;
  font-weight: bold;
  padding: 10px 20px;
  background-color: white;
}

.card-body .column {
  padding: 20px 30px;
}

.card-body .column > div {
  padding: 5px 20px;
}

.no-content {
  min-height: auto;
}

.icon {
  margin: 5px;
  height: 15px;
  width: 35px;
}

.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 10px;
}

.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}

.phone-label {
  padding-left: 0;
  padding-right: 0;
}

.password-meter {
  font-size: 12px;
}

.generate-pass {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.button-add-user,
.button-save {
  min-height: 40px;
  margin-bottom: 1rem;
  padding: 0.5rem 2rem;
  border-radius: 4px;
  border: 1px solid #b8b8b6;
  background-color: #ffffff;
  color: #2d2d2d;
  font-weight: 600;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.button-save {
  border-color: #007e1a;
  color: #007e1a;
}

.button-add-user:hover:not(:disabled) {
  background-color: #f5f4f2;
}

.button-save:hover:not(:disabled) {
  background-color: #dae6dd;
}

.button-add-user:disabled,
.button-save:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.button-save:hover {
  background-color: #005511 !important;
  border: 1px solid #005511 !important;
}

/* .button-delete {
  padding: 0.45rem 1rem 0.5rem 1rem;
}

.button-delete:hover {
  background-color: #e14544 !important;
  color: white !important;
} */

.generate {
  width: 100%;
  padding: 0.5rem 1.5rem;
}

.metrics-panel-wrap {
  display: flex;
}

.metrics-panel {
  width: 100%;
  border: 1px solid #d5d5d3;
  border-radius: 8px;
  background: #f8f8f7;
  padding: 14px;
}

.metrics-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.metrics-panel-title {
  font-size: 15px;
  font-weight: 700;
}

.metrics-panel-counter {
  font-size: 13px;
  font-weight: 700;
  color: #4f4f4f;
  background: #ececeb;
  border-radius: 999px;
  padding: 2px 10px;
}

.metrics-search {
  margin-bottom: 10px;
}

.metrics-list {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #e0e0de;
  background: #fff;
  border-radius: 6px;
}

.metrics-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 12px 12px;
  border-bottom: 1px solid #efefed;
  font-size: 15px;
  line-height: 1.2;
  cursor: pointer;
}

.metrics-item:last-child {
  border-bottom: 0;
}

.metrics-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 0;
}

.settings-feedback {
  max-width: 760px;
}

.settings-alert {
  width: 100%;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 1rem;
  font-size: 14px;
  line-height: 1.3;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid transparent;
}

.settings-alert--success {
  background: #edf8ef;
  border-color: #9fd3a8;
  color: #0f5132;
}

.settings-alert--error {
  background: #fdeeee;
  border-color: #e3a2a2;
  color: #842029;
}

.settings-alert-close {
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  opacity: 0.8;
}

.settings-alert-close:hover {
  opacity: 1;
}

.use-password {
  width: 100%;
  padding: 0.5rem 1.5rem;
  white-space: normal;
  line-height: 1.2;
}
</style>
